import { translationKey } from '../../i18n';
import { MAX_DAILY_REMINDER_TIMES } from './MedicationTimesEditor';

export function isValidDosage(value) {
    const amount = Number(value);
    return Number.isFinite(amount) && amount >= 0.01 && amount <= 99
        && /^\d*(?:\.\d{1,2})?$/.test(String(value));
}

export function reviewDraftError(draft) {
    if (!draft?.name?.trim()) return translationKey('약 이름을 입력해주세요');
    const s = draft.schedule || {};
    const integer = (v, min, max) => Number.isInteger(Number(v)) && Number(v) >= min && Number(v) <= max;
    if (!isValidDosage(draft.dosagePerTime)) return translationKey('1회 사용량을 소수 둘째 자리까지 입력해주세요');
    if (s.startDate && s.endDate && s.endDate < s.startDate) return translationKey('종료일은 시작일 이후로 정해주세요');
    if (s.frequencyType !== 'AS_NEEDED') {
        const times = s.times || [];
        if (!times.length || times.length > MAX_DAILY_REMINDER_TIMES || times.some(t => !/^([01]\d|2[0-3]):[0-5]\d$/.test(t))) return translationKey('알림 시간을 확인해주세요');
        if (new Set(times).size !== times.length) return translationKey('같은 시간은 한 번만 넣어주세요');
    }
    if (s.frequencyType === 'EVERY_N_DAYS' && !integer(s.intervalDays, 2, 365)) return translationKey('복용 간격을 입력해주세요');
    if (s.frequencyType === 'HOURLY_INTERVAL' && !integer(s.hourlyInterval, 1, 24)) return translationKey('시간 간격을 입력해주세요');
    if (s.frequencyType === 'SPECIFIC_DAYS' && !s.specificDays?.length) return translationKey('복용할 요일을 선택해주세요');
    if (s.frequencyType === 'MONTHLY' && !s.monthlyDays?.length) return translationKey('복용할 날짜를 선택해주세요');
    if (s.frequencyType === 'CYCLE' && (!integer(s.cycleDaysOn, 1, 365) || !integer(s.cycleDaysOff, 1, 365))) return translationKey('복용일과 쉬는 날을 입력해주세요');
    return null;
}
